/** @jsxImportSource @emotion/react */

import {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonItem,
    IonList,
    IonPage,
    IonTitle,
    IonToolbar,
} from '@ionic/react';
import { css } from '@emotion/react';
import React, { useEffect, useState } from 'react';

import { useCatalogues } from '../hooks/useCatalogues';
import CatalogueDetailDropdown from '../features/Catalogues/CatalogueDetailDropdown';

const TrainingCatalogues: React.FC = (): React.ReactElement => {
    const { data } = useCatalogues();
    const [catalogues, setCatalogues] = useState<Catalogue[]>([]);

    useEffect(() => {
        if (data?.catalogues) {
            setCatalogues(data.catalogues);
        }
    }, [data]);

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/" />
                    </IonButtons>
                    <IonTitle>Training catalogues</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent
                css={css`
                    --padding-bottom: 2rem;
                `}
            >
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Training catalogues</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonList>
                    {!catalogues.length ? (
                        <IonItem>
                            <h1>Empty Catalogue</h1>
                        </IonItem>
                    ) : (
                        catalogues.map((catalogue) => (
                            <CatalogueDetailDropdown key={catalogue._id} catalogue={catalogue} />
                        ))
                    )}
                </IonList>
            </IonContent>
        </IonPage>
    );
};

export default TrainingCatalogues;
